export class ContractAddressResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    async isContractAddress(network, address) {
        const provider = this.providers.find(p => p.supportsNetwork(network));
        if (!provider) {
            return false;
        }
        return provider.isContractAddress(address, network);
    }
}
